var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-description",style:({ '--background-color': _vm.template.backgroundColor, '--text-color': _vm.template.textColor, '--highlight-color': _vm.template.highlightColor })},[_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(_vm.template.text)}},[_vm._v(">")])])
}
var staticRenderFns = []

export { render, staticRenderFns }